import React, { useState } from "react";
import { Form, Progress, Button, Checkbox, Input } from "antd";
import type { CheckboxProps } from "antd";
import { toast } from "sonner";

interface FleetInformationProps {
  onFormFinish?: (values: ICreateResponderCompanyDto) => void;
  initialValues?: any;
  onPrevious: () => void;
  onNext: () => void;
  isLastStep?: boolean;
  closeModal: () => void;
}

const FleetInformation = ({
  onPrevious,
  onFormFinish,
  isLastStep,
  closeModal,
  initialValues,
}: FleetInformationProps) => {
  const [form] = Form.useForm();
  const [hasAdHocGuardingServices, setHasAdHocGuardingServices] = useState(
    initialValues?.adHocGuardingServices || false
  );

  // Sync initialValues with form
  React.useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues, form]);

  const onFinish = (values: any) => {
    console.log("FleetInformation values:", values); // Debug log
    const processedValues = {
      ...values,
      adHocGuardingServices: values.adHocGuardingServices || false,
    };
    if (onFormFinish) {
      toast.success("Saved successfully");
      onFormFinish(processedValues); // Pass processed values to parent
    }
    form.resetFields();
    // Do not call closeModal here; let the parent handle it
  };

  const onChange: CheckboxProps["onChange"] = (e) => {
    const newValue = e.target.checked;
    setHasAdHocGuardingServices(newValue);
    form.setFieldsValue({ adHocGuardingServices: newValue });
  };

  return (
    <div className="flex w-full h-full">
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        className="w-full grid"
        initialValues={initialValues}
      >
        <div className="flex flex-col w-full">
          <p className="text-sm">Step 6: Fleet Information</p>
          <Progress
            steps={6}
            size={[80, 10]}
            strokeColor={[
              "#1757A2",
              "#1757A2",
              "#1757A2",
              "#1757A2",
              "#1757A2",
              "#1757A2",
            ]}
            percent={100}
            showInfo={false}
            className="rounded-full"
            strokeLinecap="round"
            strokeWidth={1}
            style={{ height: "6px", borderRadius: "999px" }}
          />
        </div>
        <div className="col-12 md:col-6">
          <p className="text-sm">24/7 Operating Vehicles</p>
          <Form.Item
            name="vehicles24_7"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Input />
          </Form.Item>
        </div>
        <div className="col-12 md:col-6">
          <p className="text-sm">12 Hour Shift</p>
          <Form.Item
            name="vehicles12HourShift"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Input />
          </Form.Item>
        </div>
        <div className="col-12 md:col-6">
          <p className="text-sm">Armed Response Staff</p>
          <Form.Item
          name="armedResponseStaff"
          rules={[{ required: true, message: "This field is required" }]}
          >
            <Input />
          </Form.Item>
        </div>
        <div className="col-12 md:col-6">
          <p className="text-sm">Medical Staff Members</p>
          <Form.Item
          name="medicalStaffMembers"
          rules={[{ required: true, message: "This field is required" }]}
          >
            <Input />
          </Form.Item>
        </div>
        <div className="col-12 md:col-6">
          <p className="text-sm">Other Responder Staff</p>
          <Form.Item name="otherResponderStaff">
            <Input />
          </Form.Item>
        </div>
        <div className="flex w-full">
          <Form.Item name="adHocGaurdingServices" valuePropName="checked">
            <Checkbox onChange={onChange}>
              Provide ad hoc guarding services
            </Checkbox>
          </Form.Item>
        </div>
        {hasAdHocGuardingServices && (
          <div className="flex w-full">
            <Form.Item name="rate" className="w-full">
              <Input placeholder="Rate" />
            </Form.Item>
          </div>
        )}
        <div className="flex w-full">
          <Form.Item className="w-12 pt-2 mb-1">
            <div className="flex w-full gap-2 col-12 justify-content-end align-content-center">
              <Button
                type="primary"
                ghost
                onClick={onPrevious}
                size="large"
                className="w-3"
              >
                Back
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                className="w-3 bg-[#1757A2]"
              >
                Save
              </Button>
            </div>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default FleetInformation;
